import { merge } from "lodash";
import ReactApexChart from "react-apexcharts";
import Moment from "moment";
import { DownloadTableExcel } from "react-export-table-to-excel";
// material
import {
  Box,
  Card,
  CardHeader,
  Grid,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TablePagination,
  TableRow,
} from "@mui/material";
import { fNumber } from "../../utils/formatNumber";
import { BaseOptionChart } from "../../components/charts";
import ReportWidgetSummary from "./reportedias/ReportWidgetSummary";
import Scrollbar from "../../components/Scrollbar";
import MovimientosHeader from "../../components/TableHeader/MovimientosHeader";
import { useRef, useState } from "react";
const TABLE_HEAD = [
  { id: "turno", label: "Turno", alignRight: false },
  { id: "tipo", label: "Tipo", alignRight: false },
  { id: "totalPermisos", label: "Total de Permisos", alignRight: false },
  { id: "totalFolios", label: "Total de Folios", alignRight: false },
  { id: "folio", label: "Folios", alignRight: false },
  { id: "diaTrabajo", label: "Dia de Trabajo", alignRight: false },
  { id: "fechaTrabajo", label: "Fecha de Trabajo", alignRight: false },
  { id: "fechaReporte", label: "Fecha de Reporte", alignRight: false },
  { id: "delegado", label: "Delegado", alignRight: false },
  { id: "plaza", label: "Plaza", alignRight: false },
  { id: "monto", label: "Monto", alignRight: false },
  { id: "comision", label: "Comisión", alignRight: false },
  { id: "neto", label: "Neto", alignRight: false },
];
const ReportePorDia = ({ datos, leyendas }) => {
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const tableRef = useRef(null);

  //Longitud
  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };
  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };
  let result = [];
  let comisiones = [];
  let netoa = [];
  let delegados = [];
  let prueba = [];
  function subTotal(reporteCobrosPorDia) {
    return reporteCobrosPorDia
      .map(({ MovimientosModel }) => MovimientosModel.monto)
      .reduce((sum, i) => sum + i, 0);
  }

  function comisionesTotalSum(comisiones) {
    return datos
      .map(({ MovimientosModel }) => MovimientosModel.comision)
      .reduce((sum, i) => sum + i, 0);
  }

  //Operaciones
  const ingresSubTotal = subTotal(datos);
  const comisionesTotal = comisionesTotalSum(datos);
  // eslint-disable-next-line array-callback-return
  datos.map((r) => {
    const { MovimientosModel, PersonasModel } = r;
    prueba.push({
      monto: MovimientosModel.monto,
      comision: MovimientosModel.comision,
      neto: MovimientosModel.neto,
      delegado: PersonasModel.nombre,
    });
  });

  var re = prueba
    .reduce(
      function (res, obj) {
        if (!(obj.delegado in res)) res.__array.push((res[obj.delegado] = obj));
        else {
          res[obj.delegado].monto += obj.monto;
          res[obj.delegado].neto += obj.neto;
          res[obj.delegado].comision += obj.comision;
        }
        return res;
      },
      { __array: [] }
    )
    .__array.sort(function (a, b) {
      return b.monto - a.monto;
    });

  re.map((r) => {
    const { monto, neto, comision, delegado } = r;
    result.push(monto);
    comisiones.push(comision);
    netoa.push(neto);
    delegados.push(delegado);
  });

  const chartOptions = merge(BaseOptionChart(), {
    chart: {
      toolbar: {
        show: true,
        offsetX: 0,
        offsetY: -20,
        tools: {
          download: true,
          selection: true,
          zoom: true,
          zoomin: true,
          zoomout: true,
          pan: true,
          reset: true | '<img src="/static/icons/reset.png" width="20">',
          customIcons: [],
        },
        export: {
          csv: {
            filename: undefined,
            columnDelimiter: ",",
            headerCategory: "Delegado",
            headerValue: "value",
            dateFormatter(timestamp) {
              return new Date(timestamp).toDateString();
            },
          },
          svg: {
            filename: undefined,
          },
          png: {
            filename: undefined,
          },
        },
        autoSelected: "zoom",
      },
    },
    tooltip: {
      marker: { show: true },
      y: {
        formatter: (seriesName) => fNumber(seriesName),
        title: {
          formatter: (seriesName) => `#${seriesName}`,
        },
      },
    },

    plotOptions: {
      bar: {
        horizontal: false,
        barHeight: "50%",
        borderRadius: 2,
        dataLabels: { position: "bottom" },
      },
    },
    xaxis: {
      categories: delegados,
    },
  });

  const CHART_DATA = [
    { name: "Ingreso Bruto", data: result },
    { name: "Ingreso neto", data: netoa },
    { name: "Comisiones", data: comisiones },
  ];

  return (
    <>
      <Grid container spacing={3}>
        {/* <Grid item xs={12} sm={6} md={4}>
          <ReportWidgetSummary
            title="Ingreso Bruto"
            color="ingresoColor"
            total={ingresSubTotal}
            icon={"ant-design:dollar-circle-filled"}
          />
        </Grid>
        <Grid item xs={12} sm={6} md={4}>
          <ReportWidgetSummary
            title="Ingreso Neto"
            color="ingresoNetoColor"
            total={ingresSubTotal - comisionesTotal}
            icon={"ant-design:dollar-circle-filled"}
          />
        </Grid>
        <Grid item xs={12} sm={6} md={4}>
          <ReportWidgetSummary
            title="Comisiones"
            color="comisionesColor"
            total={comisionesTotal}
            icon={"ant-design:dollar-circle-filled"}
          />
        </Grid> */}

        <Grid item xs={12} md={6} lg={12}>
          <br />
          <Card>
            <CardHeader title={`${leyendas}`} />
            {/* <Box sx={{ mx: 3 }} dir="ltr">
              <ReactApexChart
                type="bar"
                options={chartOptions}
                series={CHART_DATA}
                height={364}
              />
            </Box> */}

            <Scrollbar>
              <DownloadTableExcel
                filename="Reporte ejecutivo de Fechas"
                sheet="reporte"
                currentTableRef={tableRef.current}
              >
                <button> Exportar a Excel </button>
              </DownloadTableExcel>
              <TableContainer sx={{ minWidth: 800 }}>
                <Table>
                  <MovimientosHeader headLabel={TABLE_HEAD} />
                  <TableBody>
                    {datos
                      .slice(
                        page * rowsPerPage,
                        page * rowsPerPage + rowsPerPage
                      )
                      .map((row) => {
                        const {
                          id,
                          turno,
                          fechaTrabajo,
                          folioIngreso,
                          totalFolios,
                          tipo,
                          fechaReporte,
                          PersonasModel,
                          PlazaModel,
                          MovimientosModel,
                          totalPermisos,
                        } = row;
                        return (
                          <TableRow hover key={id} tabIndex={-1}>
                            <TableCell>
                              {
                                {
                                  1: "Matutino",
                                  2: "Vespertino",
                                  3: "Diurno",
                                }[turno]
                              }
                            </TableCell>
                            <TableCell>
                              {
                                {
                                  1: "Basura",
                                  2: "Permiso",
                                }[tipo]
                              }
                            </TableCell>
                            <TableCell>{totalPermisos}</TableCell>
                            <TableCell>{totalFolios}</TableCell>
                            <TableCell>{folioIngreso}</TableCell>
                            <TableCell>
                              {" "}
                              {Moment(fechaTrabajo).format("dddd")}
                            </TableCell>
                            <TableCell>
                              {Moment(fechaTrabajo).format("DD-MMMM-YYYY")}
                            </TableCell>
                            <TableCell>
                              {Moment(fechaReporte).format("DD-MMMM-YYYY")}
                            </TableCell>

                            <TableCell>
                              {PersonasModel.nombre} {PersonasModel.apellidos}
                            </TableCell>
                            <TableCell>{PlazaModel.nombre}</TableCell>

                            <TableCell>$ {MovimientosModel.monto}</TableCell>
                            <TableCell>${MovimientosModel.comision}</TableCell>
                            <TableCell>${MovimientosModel.neto}</TableCell>
                          </TableRow>
                        );
                      })}
                    <TableRow>
                      <TableCell colSpan={10}></TableCell>
                      <TableCell>$ {ingresSubTotal}</TableCell>
                      <TableCell>$ {comisionesTotal}</TableCell>
                      <TableCell>
                        $ {ingresSubTotal - comisionesTotal}
                      </TableCell>
                    </TableRow>
                  </TableBody>
                </Table>
              </TableContainer>

              <TableContainer sx={{ minWidth: 800 }} hidden>
                <Table ref={tableRef}>
                  <MovimientosHeader headLabel={TABLE_HEAD} />
                  <TableBody>
                    {datos.map((row) => {
                      const {
                        id,
                        turno,
                        fechaTrabajo,
                        folioIngreso,
                        totalFolios,
                        tipo,
                        fechaReporte,
                        PersonasModel,
                        PlazaModel,
                        MovimientosModel,
                        totalPermisos,
                      } = row;
                      return (
                        <TableRow hover key={id} tabIndex={-1}>
                          <TableCell>
                            {
                              {
                                1: "Matutino",
                                2: "Vespertino",
                                3: "Diurno",
                              }[turno]
                            }
                          </TableCell>
                          <TableCell>
                            {
                              {
                                1: "Basura",
                                2: "Permiso",
                              }[tipo]
                            }
                          </TableCell>
                          <TableCell>{totalPermisos}</TableCell>
                          <TableCell>{totalFolios}</TableCell>
                          <TableCell>{folioIngreso}</TableCell>
                          <TableCell>
                            {" "}
                            {Moment(fechaTrabajo).format("dddd")}
                          </TableCell>
                          <TableCell>
                            {Moment(fechaTrabajo).format("DD-MMMM-YYYY")}
                          </TableCell>
                          <TableCell>
                            {Moment(fechaReporte).format("DD-MMMM-YYYY")}
                          </TableCell>

                          <TableCell>
                            {PersonasModel.nombre} {PersonasModel.apellidos}
                          </TableCell>
                          <TableCell>{PlazaModel.nombre}</TableCell>

                          <TableCell>$ {MovimientosModel.monto}</TableCell>
                          <TableCell>${MovimientosModel.comision}</TableCell>
                          <TableCell>${MovimientosModel.neto}</TableCell>
                        </TableRow>
                      );
                    })}
                    <TableRow>
                      <TableCell colSpan={10}></TableCell>
                      <TableCell>$ {ingresSubTotal}</TableCell>
                      <TableCell>$ {comisionesTotal}</TableCell>
                      <TableCell>
                        $ {ingresSubTotal - comisionesTotal}
                      </TableCell>
                    </TableRow>
                  </TableBody>
                </Table>
              </TableContainer>
            </Scrollbar>
            <TablePagination
              rowsPerPageOptions={[5, 10, 25]}
              component="div"
              page={page}
              count={datos.length}
              rowsPerPage={rowsPerPage}
              onPageChange={handleChangePage}
              onRowsPerPageChange={handleChangeRowsPerPage}
            />
          </Card>
        </Grid>
      </Grid>
    </>
  );
};

export default ReportePorDia;
